import { Session } from 'next-auth'
import { AddressDetails, AddressSuggestion } from 'shared-types'

import { IAddressfinderClient } from '../types/Client'
import { request } from './request'

const ADDRESSFINDER_DETAILS_STORAGE_KEY = 'addressCache'

export class AddressfinderClient implements IAddressfinderClient {
  private cacheAddressDetails = (
    address: string,
    addressDetails: AddressDetails
  ) => {
    const addresses: { [key: string]: AddressDetails } = JSON.parse(
      sessionStorage.getItem(ADDRESSFINDER_DETAILS_STORAGE_KEY) || '{}'
    )

    addresses[address] = addressDetails

    try {
      sessionStorage.setItem(
        ADDRESSFINDER_DETAILS_STORAGE_KEY,
        JSON.stringify(addresses)
      )
    } catch {}
  }

  private getCachedAddressDetails = (
    address: string
  ): AddressDetails | null => {
    const addresses: { [key: string]: AddressDetails } = JSON.parse(
      sessionStorage.getItem(ADDRESSFINDER_DETAILS_STORAGE_KEY) || '{}'
    )

    return addresses[address] || null
  }

  getAddressSuggestions = async (
    address: string,
    session: Session
  ): Promise<AddressSuggestion[]> => {
    const response = await request<AddressSuggestion[]>(
      {
        url: `bff/addressfinder/address?address=${address}`,
        method: 'POST',
      },
      session
    )
    if (response.getErrorSafe()) {
      return null
    }

    return response.getValueSafe()
  }

  getAddressDetailsByQuery = async (
    address: string,
    session: Session
  ): Promise<AddressDetails | null> => {
    const cacheAddressDetails = this.getCachedAddressDetails(address)

    if (cacheAddressDetails) {
      return cacheAddressDetails
    }

    const response = await request<AddressDetails>(
      {
        url: `bff/addressfinder/verify?address=${address}`,
        method: 'POST',
      },
      session
    )
    if (response.getErrorSafe()) {
      return null
    }

    const addressDetails = response.getValueSafe()
    this.cacheAddressDetails(address, addressDetails)

    return addressDetails
  }

  clearCache = () => {
    sessionStorage.removeItem(ADDRESSFINDER_DETAILS_STORAGE_KEY)
  }
}
